<template>
  <v-tooltip left :disabled="!showTooltip">
    <template #activator="{ on }">
      <v-icon small :color="color" v-on="on">
        $freshvuenotes-severity-{{ severity }}
      </v-icon>
    </template>
    <span>
      {{ $t('fresh-vue-notes.fields.severity') }}:
      {{ $t(`fresh-vue-notes.severity.${severity}`) }}
    </span>
  </v-tooltip>
</template>

<script>
export default {
  name: 'NoteSeverityIcon',

  props: {
    severity: {
      type: String,
      required: false,
      default: 'NONE'
    },

    showTooltip: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  computed: {
    color() {
      switch (this.severity) {
        case 'NONE':
          return null
        case 'INFO':
          return 'info'
        case 'SUCCESS':
          return 'success'
        case 'WARNING':
          return 'warning'
        case 'ERROR':
          return 'error'
        default:
          return null
      }
    }
  }
}
</script>
